import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { ModalType } from '@/models/Modal.ts';
import { TaskSortByOption } from '@/models/SortByOption.ts';
import { TaskModalMode } from '@/models/TaskModalMode.ts';
import { EnrichedTask } from '@/models/doc-cirrus/DCTask.ts';

import { closeModal } from '@/services/modalService.tsx';

type TaskViewStore = {
    is_completed_column_shown: boolean;
    is_only_me_selected: boolean;
    show_task_list: boolean;
    task_list: EnrichedTask[];
    task_modal_mode: TaskModalMode;
    selected_task_id?: string;
    selected_task_instance_id?: string;
    search_text: string;
    sort_by: TaskSortByOption;
    // Pagination state (not persisted)
    new_tasks_page: number;
    assigned_tasks_page: number;
    done_tasks_page: number;
    // Drag and drop state (not persisted)
    dragging_task: EnrichedTask | undefined;
    // Actions
    onCloseModal: () => void;
};

export const useTaskViewStore = create<TaskViewStore>()(
    persist(
        (set, get): TaskViewStore => ({
            is_completed_column_shown: false,
            is_only_me_selected: false,
            show_task_list: false,
            task_list: [],
            task_modal_mode: TaskModalMode.DETAILS,
            selected_task_id: undefined,
            selected_task_instance_id: undefined,
            search_text: '',
            sort_by: TaskSortByOption.CREATED_ASC,
            // Pagination state
            new_tasks_page: 1,
            assigned_tasks_page: 1,
            done_tasks_page: 1,
            // Drag and drop state
            dragging_task: undefined,
            // Actions
            onCloseModal: (): void => {
                const selected_task_id = get().selected_task_id;
                if (selected_task_id) {
                    set({ task_modal_mode: TaskModalMode.DETAILS });
                } else {
                    closeModal(ModalType.TASK);
                }
            },
        }),
        {
            name: 'task_view_store',
            partialize: (state) => ({
                // Only these fields are persisted
                is_completed_column_shown: state.is_completed_column_shown,
                is_only_me_selected: state.is_only_me_selected,
            }),
        }
    )
);
